module.exports = __webpack_public_path__ + "static/img/banner_4.c7cb7af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_4.png
// module id = 3vnn
// module chunks = 2